import Vue from "vue"
import App from "./App.vue"
import Vuex from "vuex"
import store from "@/store/index"
import router from "@/router/router"
import VueRouter from "vue-router"
import moment from 'vue-moment';
// import VueGtag from "vue-gtag";
import VueObserveVisibility from 'vue-observe-visibility'
import vueVimeoPlayer from 'vue-vimeo-player'
// import ToastService from 'primevue/toastservice';

Vue.config.productionTip = false;

Vue.use(Vuex);

Vue.use(VueRouter);
Vue.use(moment);
Vue.use(VueObserveVisibility)
Vue.use(vueVimeoPlayer)


// Vue.use(VueGtag, {

//   config: { id: "UA-33688687-5" }
  
// }, router);

// Vue.use(ToastService)


new Vue({
  render: h => h(App),
  store,
  router
}).$mount("#app");
